<template>
    <div class="about-initiative-form3">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group>
                <div class="label-created required">
                    Público motivador da iniciativa
                    <span id="rg-rne-help" class="icon-tooltip">
                        <img :src="require(`@/assets/Cadastro/responsavel/help-icon.svg`)" alt=""
                    /></span>

                    <b-tooltip target="rg-rne-help">
                        É possível indicar mais de um segmento
                    </b-tooltip>
                </div>

                <b-form-select
                    id="agePublic"
                    name="agePublic"
                    v-model="$v.form.agePublic.selected.$model"
                    :options="form.agePublic.options"
                    :state="validateState('agePublic')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['id_publicoMotivador'].value)
                    "
                ></b-form-select>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_publicoMotivador'].value"
                />

                <b-form-invalid-feedback :state="validateState('agePublic')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Bioma em que a iniciativa atua" label-for="biome" class="required">
                <b-form-select
                    id="biome"
                    name="biome"
                    v-model="$v.form.biome.selected.$model"
                    :options="form.biome.options"
                    :state="validateState('biome')"
                    :disabled="getIsDisabled"
                    v-if="!isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['id_bioma'].value)"
                ></b-form-select>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_bioma'].value"
                />

                <b-form-invalid-feedback :state="validateState('biome')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Qual a dimensão que melhor descreve o impacto social produzido pela sua iniciativa?"
                label-for="socialImpact"
                class="required"
            >
                <b-form-radio-group
                    id="socialImpact"
                    name="socialImpact"
                    v-model="$v.form.socialImpact.selected.$model"
                    :options="form.socialImpact.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('socialImpact')"
                    :disabled="getIsDisabled"
                    stacked
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['dimensao_impacto_social'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['dimensao_impacto_social'].value"
                />

                <b-form-invalid-feedback :state="validateState('socialImpact')">
                    <div v-if="!$v.form.socialImpact.selected.required">Campo obrigatório</div>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Indique se sua iniciativa possui algum título ou qualificação e qual"
                label-for="titleQualification"
                class="required"
            >
                <b-form-checkbox-group
                    id="title-qualification"
                    name="titleQualification"
                    v-model="$v.form.titleQualification.selected.$model"
                    :options="getTitleQualificationOptions"
                    value-field="item"
                    text-field="text"
                    :state="validateState('titleQualification')"
                    :disabled="getIsDisabled"
                    @change="onChangeTitleQualification()"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['iniciativa_possuo_titulo'].value)
                    "
                >
                    <div>
                        <div
                            class="checkbox-input"
                            v-if="
                                !this.receiveData || (this.receiveData && form.titleQualification.selected.includes(9))
                            "
                        >
                            <b-form-checkbox
                                v-model="$v.form.titleQualification.selected.$model"
                                :value="9"
                                :state="validateState('titleQualification')"
                                :disabled="getIsDisabled"
                            >
                                Outros
                            </b-form-checkbox>

                            <div class="md-6">
                                <b-form-input
                                    name="titleQualificationOthers"
                                    style="margin-bottom: 20px;"
                                    v-model="form.titleQualificationOthers"
                                    placeholder="Digite aqui ..."
                                    :disabled="getIsDisabled"
                                    v-if="form.titleQualification.selected.includes(9)"
                                ></b-form-input>
                            </div>
                        </div>

                        <div
                            class="checkbox-input"
                            v-if="
                                !this.receiveData || (this.receiveData && form.titleQualification.selected.includes(10))
                            "
                        >
                            <b-form-checkbox
                                style="width: 95%"
                                v-model="$v.form.titleQualification.selected.$model"
                                :value="10"
                                :state="validateState('titleQualification')"
                                :disabled="getIsDisabled"
                            >
                                Não se aplica
                            </b-form-checkbox>
                        </div>
                    </div>
                </b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['iniciativa_possuo_titulo'].value"
                />

                <b-form-invalid-feedback :state="validateState('titleQualification')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'AboutInitiativeForm2' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('AboutInitiativeForm2')"
                        >Voltar</b-button
                    >

                    <b-button :variant="'primary'" @click="changeRegisterForm('AboutInitiativeForm4')">
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { required } from 'vuelidate/lib/validators'
import { AboutInitiativeApi } from '../../api/about-initiative'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const aboutInitiativeApi = new AboutInitiativeApi()

export default {
    components: { DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDisabled: null,
            profileId: this.$store.state.profileId,
            progress: 24.93,
            initiative: null,
            message: null,
            isUpdate: false,
            authorizationData: null,
            form: {
                agePublic: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                biome: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                socialImpact: {
                    selected: null,
                    options: [
                        { text: 'Melhoria das condições de saúde', item: 1, value: 1 },
                        { text: 'Melhorias em saneamento e/ou água', item: 2, value: 2 },
                        { text: 'Melhoria das condições educacionais', item: 3, value: 3 },
                        {
                            text: 'Redução dos custos de transação (crédito, compras, empreendimentos)',
                            item: 4,
                            value: 4
                        },
                        { text: 'Melhoria das condições de habitação', item: 5, value: 5 },
                        {
                            text: 'Proteção socioambiental de áreas rurais e comunidades tradicionais',
                            item: 6,
                            value: 6
                        },
                        { text: 'Melhoria das condições ambientais urbanas', item: 7, value: 7 },
                        {
                            text: 'Diminuição do risco da família cair em situações de pobreza extrema',
                            item: 8,
                            value: 8
                        },
                        { text: 'Melhorias no meio ambiente', item: 9, value: 9 },
                        { text: 'Proteção de Direitos Humanos', item: 11, value: 11 },
                        { text: 'Melhoria do protagonismo local', item: 12, value: 12 },
                        { text: 'Geração de emprego/renda', item: 13, value: 13 },
                        { text: 'Desenvolvimento comunitário', item: 14, value: 14 }
                    ]
                },
                titleQualification: {
                    selected: [],
                    options: [
                        {
                            text: 'OSCIP - Organização da Sociedade Civil de Interesse Público',
                            item: 1,
                            value: 1,
                            show: true
                        },
                        { text: 'UPF - Utilidade Pública Federal', item: 2, value: 2, show: true },
                        { text: 'UPE - Utilidade Pública Estadual', item: 3, value: 3, show: true },
                        { text: 'UPM - Utilidade Pública Municipal', item: 4, value: 4, show: true },
                        {
                            text: 'CEBAS – Certificado de Entidade Beneficente de Assistência Social',
                            item: 5,
                            value: 5,
                            show: true
                        },
                        {
                            text: 'Inscrição no CMAS – Conselho Municipal de Assistência Social',
                            item: 6,
                            value: 6,
                            show: true
                        },
                        {
                            text: 'Inscrição no CNAS – Conselho Nacional de Assistência Social',
                            item: 7,
                            value: 7,
                            show: true
                        },
                        {
                            text:
                                'Inscrição nos Conselhos de Direito Específico: Direitos da Criança e do Adolescente; de Saúde, do Idoso, da Pessoa com Deficiência, outros',
                            item: 8,
                            value: 8,
                            show: true
                        }
                    ]
                },
                titleQualificationOthers: null
            }
        }
    },
    validations: {
        form: {
            biome: {
                selected: { required }
            },
            agePublic: {
                selected: { required }
            },
            socialImpact: {
                selected: {
                    required
                }
            },
            titleQualification: {
                selected: { required }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData
            this.initiative = data

            this.form.agePublic.selected = data.id_publicoMotivador
            this.form.biome.selected = data.id_bioma
            this.form.socialImpact.selected = data.dimensao_impacto_social
            this.form.titleQualification.selected = data.iniciativa_possuo_titulo || []

            this.form.titleQualificationOthers =
                data.iniciativa_possuo_titulo === null
                    ? null
                    : data.iniciativa_possuo_titulo.filter(item => typeof item !== 'number')

            this.form.titleQualificationOthers =
                this.form.titleQualificationOthers !== null && this.form.titleQualificationOthers.length
                    ? this.form.titleQualificationOthers[0].titleQualificationOthers
                    : null

            this.setIsLoading(true)

            axios
                .all([aboutInitiativeApi.getMotivatingAudience(), aboutInitiativeApi.getBiome()])
                .then(response => {
                    this.form.agePublic.options.push(
                        ...response[0].data.map(item => ({ value: item.id, text: item.publico_motivador }))
                    )

                    this.form.biome.options.push(
                        ...response[1].data.map(item => ({ value: item.id, text: item.bioma }))
                    )

                    this.fetchAuthorization()
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.filterData()
                    this.setIsLoading(false)
                })
        },
        fetch() {
            this.setIsLoading(true)

            axios
                .all([
                    aboutInitiativeApi.getAboutInitiative(),
                    aboutInitiativeApi.getMotivatingAudience(),
                    aboutInitiativeApi.getBiome()
                ])
                .then(response => {
                    const data = response[0].data.data

                    if (data !== null) {
                        this.initiative = data
                        this.form.agePublic.selected = data.id_publicoMotivador
                        this.form.biome.selected = data.id_bioma
                        this.form.socialImpact.selected = data.dimensao_impacto_social
                        this.form.titleQualification.selected = data.iniciativa_possuo_titulo || []

                        this.form.titleQualificationOthers =
                            data.iniciativa_possuo_titulo === null
                                ? null
                                : data.iniciativa_possuo_titulo.filter(item => typeof item !== 'number')

                        this.form.titleQualificationOthers =
                            this.form.titleQualificationOthers !== null && this.form.titleQualificationOthers.length
                                ? this.form.titleQualificationOthers[0].titleQualificationOthers
                                : null
                    }

                    this.form.agePublic.options.push(
                        ...response[1].data.map(item => ({ value: item.id, text: item.publico_motivador }))
                    )

                    this.form.biome.options.push(
                        ...response[2].data.map(item => ({ value: item.id, text: item.bioma }))
                    )
                })
                .catch(error => {
                    this.message = error.response
                        ? error.response.data.message
                        : 'Erro ao obter dados: "Sobre a Iniciativa"'
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.initiative,
                id_publicoMotivador: this.form.agePublic.selected,
                id_bioma: this.form.biome.selected,
                dimensao_impacto_social: this.form.socialImpact.selected,
                iniciativa_possuo_titulo: this.form.titleQualification.selected,
                percentual: currentProgress
            }

            data.iniciativa_possuo_titulo.forEach(el => {
                if (typeof el === 'object') {
                    if (Object.keys(el).includes('titleQualificationOthers')) {
                        el.titleQualificationOthers = this.form.titleQualificationOthers
                    }
                }
            })

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutInitiativeApi.updateAboutInitiative(data)
                : aboutInitiativeApi.nextAboutInitiative(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.$router.push({ name: 'AboutInitiativeForm4' })
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        onChangeTitleQualification() {
            if (this.form.titleQualification.selected.includes(10)) {
                this.form.titleQualification.selected = [10]
            }
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAboutInitiative(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        filterData() {
            if (this.receiveData) {
                this.form.titleQualification.options = this.form.titleQualification.options.filter(x =>
                    this.form.titleQualification.selected.includes(x.value)
                )
                this.form.socialImpact.options = this.form.socialImpact.options.filter(
                    x => Number(this.form.socialImpact.selected) === x.value
                )
            }
        }
    },
    computed: {
        getTitleQualificationOptions() {
            // return this.form.titleQualification.options.filter(opt =>
            //     this.profileId === 1 ? opt : [1, 2, 3, 4, 9, 10].includes(opt.item)
            // )
            return this.form.titleQualification.options
        },
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getProgress() {
            return this.$store.state.progress
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutInitiativeForm3-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-initiative-forms/AboutInitiativeForm3.vue